import { useMutation } from "react-query";
import { verifyAccountInvite } from "../api/account/verifyAccountInvite";

export const useMutationVerifyAccountInvite = () =>
  useMutation("account-invite", verifyAccountInvite, {
    // onSettled: () => queryClient.invalidateQueries([...USER_DETAILS_QUERY_KEY]),
  });
